/*
 * Project: LegalPlace assistant
 * File: src\components\misc\static.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { guid } from '../utils/misc';
import { initOutputOption, initOutputVariable, editOption } from '../../redux/actions/output';
import { lpGetOptionById, lpGetVariableById } from '../../logic/re_index';

import LpHelper from './helper';
import lpApp from '../../app/lp_app';

class SingleText extends Component {
  componentWillMount() {
    if (!this.props.exists) {
      if (this.props.isDuplicate) {
        this.props.initializeFlat(`${this.props.id}_${this.props.copy}`);
        this.props.initializeOutput(`${this.props.id}_${this.props.copy}`, this.props.parentId, this.props.ovc, this.props.label);
      } else {
        this.props.initializeFlat(this.props.id);
        this.props.initializeOutput(
          this.props.id,
          this.props.parentId,
          this.props.ovc,
          this.props.label,
        );
      }
    }
  }

  render() {
    // TODO: add the unique key to a big table
    return (
      <div>
        <span key={guid()} data-type="variable-container" data-id={this.props.id} data-is-duplicate={this.props.isDuplicate} data-copy={this.props.copy}>
          { this.props.label }
          {' '}
          {'helper' in lpApp.references.getOption(this.props.id).meta && lpApp.references.getOption(this.props.id).meta.helper.length > 0 && <LpHelper text={lpApp.references.getOption(this.props.id).meta.helper} />}
        </span>

      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  initializeFlat: (id) => {
    if (ownProps.ovc === 'o') dispatch(initOutputOption(id, ownProps.lpKey, true));
    if (ownProps.ovc === 'v') dispatch(initOutputVariable(id, ownProps.lpKey, true));
    return null;
  },
  initializeOutput: (id, parent, genre, value = '') => {
    // console.log("Init statics " + id)
    if (genre === 'o') dispatch(initOutputOption(id, parent, value));
    else if (genre === 'v') dispatch(initOutputVariable(id, parent, value));
  },
  editOption: (id, val) => {
    if (ownProps.ovc === 'o') dispatch(editOption(id, val));
  },
});

const mapStateToProps = (state, ownProps) => {
  let exists = false;
  const realId = ownProps.isDuplicate ? `${ownProps.id}_${ownProps.copy}` : ownProps.id;
  if (ownProps.ovc === 'o') {
    if (typeof lpGetOptionById(realId) !== 'undefined') {
      exists = true;
    }
  }
  if (ownProps.ovc === 'v') {
    if (typeof lpGetVariableById(realId) !== 'undefined') {
      exists = true;
    }
  }
  return {
    sectionId: state.contract.currentSection,
    exists,
  };
};

const LpSingleText = connect(mapStateToProps, mapDispatchToProps)(SingleText);

export default LpSingleText;



// WEBPACK FOOTER //
// ./src/components/misc/static.js